import { render, staticRenderFns } from "./alertTurnOff.vue?vue&type=template&id=44a1443d&scoped=true"
import script from "./alertTurnOff.vue?vue&type=script&lang=js"
export * from "./alertTurnOff.vue?vue&type=script&lang=js"
import style0 from "./alertTurnOff.vue?vue&type=style&index=0&id=44a1443d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a1443d",
  null
  
)

export default component.exports